import QuillEventBus, { QuillEvents } from '@/components/texteditor/event-bus';
import AdvancedLink from '@/components/texteditor/advanced/blots/advancedLinkInline';
import config from '../config/advanced';

export default function advancedLinkHandler() {
  const range = this.quill.getSelection();
  // el cursor no está en el editor
  if (!range) {
    return;
  }
  let linkRange = range;
  let entity = {};
  const [link, offset] = this.quill.scroll.descendant(
    AdvancedLink,
    range.index,
  );

  if (link) {
    linkRange = { index: range.index - offset, length: Math.max(link.length(), range.length) };
    entity = AdvancedLink.formats(link.domNode);
  }

  const [prevLink, prevOffset] = this.quill.scroll.descendant(
    AdvancedLink,
    range.index - 1,
  );

  if (!link && prevLink && prevOffset > 0) {
    linkRange = { index: range.index - (prevOffset + 1), length: prevLink.length() };
    entity = AdvancedLink.formats(prevLink.domNode);
  }

  const dialogConfig = config.toolbar['ql-advanced-link'];
  const text = this.quill.getText(linkRange.index, linkRange.length);

  const message = {
    uuid: this.quill.uuid,
    params: {
      dialogConfig,
      fields: {
        text,
        entity,
        range: linkRange,
      },
    },
  };

  QuillEventBus.$emit(QuillEvents.CREATE, message);
}
